__turbopack_context__.v({
  "desktop": "FocusAreaSection-module-scss-module__OA5U6a__desktop",
  "embla": "FocusAreaSection-module-scss-module__OA5U6a__embla",
  "emblaContainer": "FocusAreaSection-module-scss-module__OA5U6a__emblaContainer",
  "mobile": "FocusAreaSection-module-scss-module__OA5U6a__mobile",
  "mobileDescription": "FocusAreaSection-module-scss-module__OA5U6a__mobileDescription",
  "mobileEmbla": "FocusAreaSection-module-scss-module__OA5U6a__mobileEmbla",
  "mobileEmblaContainer": "FocusAreaSection-module-scss-module__OA5U6a__mobileEmblaContainer",
  "mobileHeader": "FocusAreaSection-module-scss-module__OA5U6a__mobileHeader",
  "mobileHeaderTitle": "FocusAreaSection-module-scss-module__OA5U6a__mobileHeaderTitle",
  "mobileTitle": "FocusAreaSection-module-scss-module__OA5U6a__mobileTitle",
  "mobileTitleSection": "FocusAreaSection-module-scss-module__OA5U6a__mobileTitleSection",
  "mobileVisionLink": "FocusAreaSection-module-scss-module__OA5U6a__mobileVisionLink",
  "progressBar": "FocusAreaSection-module-scss-module__OA5U6a__progressBar",
  "progressFill": "FocusAreaSection-module-scss-module__OA5U6a__progressFill",
  "progressTrack": "FocusAreaSection-module-scss-module__OA5U6a__progressTrack",
});
